import { HTMLAttributes } from "react";
import styled from "styled-components";

export function formatPhoneNumber(number?: string) {
  if (!number) return number;
  if (/^\+47/.test(number) && number.length === 11) {
    return [
      number.slice(0, 3),
      number.slice(3, 6),
      number.slice(6, 8),
      number.slice(8),
    ].join(" ");
  }

  if (number.length !== 8) return number;

  return [number.slice(0, 3), number.slice(3, 5), number.slice(5)].join(" ");
}

export interface PhoneNumberProps
  extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  number?: string;
}

const PhoneNumber = styled(({ number, ...props }: PhoneNumberProps) => {
  return <span {...props}>{formatPhoneNumber(number)}</span>;
})`
  white-space: nowrap;
`;

export default PhoneNumber;
